module.exports = __webpack_public_path__ + "static/media/mobile-game-protection-3.94e4d929.jpg";